import * as React from 'react';

import type { TypedLineChart } from './LineChart.lazy';

export const LineChart = React.lazy(() =>
    import('./LineChart.lazy').then((module) => ({
        default: module.LineChart,
    }))
) as TypedLineChart;

export type { LineChartProps } from './LineChart.lazy';
